import { Link } from "@inertiajs/react"
import { Wordmark } from "./Wordmark"

export function MarketingFooter() {
  return (
    <footer className="border-t border-hairline bg-surface">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <Wordmark />
            <p className="mt-3 text-sm text-ink-muted">
              Founder-led podcast strategy and production that helps established
              experts build authority through better conversations.
            </p>
            <Link
              href="/apply"
              className="mt-4 inline-block text-sm font-medium text-accent-display no-underline hover:underline"
            >
              Apply for a Podcast Growth Fit Call →
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-10 sm:grid-cols-3 sm:gap-16">
            <div>
              <h2 className="footer-heading">Company</h2>
              <ul className="mt-3 space-y-2 text-sm">
                <li>
                  <Link href="/about" className="text-ink-body no-underline hover:text-ink-display">
                    About
                  </Link>
                </li>
                <li>
                  <a href="/#offer" className="text-ink-body no-underline hover:text-ink-display">
                    The Partnership
                  </a>
                </li>
                <li>
                  <Link href="/blog" className="text-ink-body no-underline hover:text-ink-display">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link href="/apply" className="text-ink-body no-underline hover:text-ink-display">
                    Apply
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="footer-heading">Services</h2>
              <ul className="mt-3 space-y-2 text-sm">
                <li>
                  <Link
                    href="/podcast-production"
                    className="text-ink-body no-underline hover:text-ink-display"
                  >
                    Podcast Production
                  </Link>
                </li>
                <li>
                  <Link href="/seo" className="text-ink-body no-underline hover:text-ink-display">
                    Local SEO
                  </Link>
                </li>
                <li>
                  <Link
                    href="/podcast-audit"
                    className="text-ink-body no-underline hover:text-ink-display"
                  >
                    Free Podcast Audit
                  </Link>
                </li>
                <li>
                  <Link href="/ai" className="text-ink-body no-underline hover:text-ink-display">
                    AI Visibility
                  </Link>
                </li>
                <li>
                  <Link href="/stack" className="text-ink-body no-underline hover:text-ink-display">
                    The Stack
                  </Link>
                </li>
                <li>
                  <Link href="/books" className="text-ink-body no-underline hover:text-ink-display">
                    Book Library
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="footer-heading">Connect</h2>
              <ul className="mt-3 space-y-2 text-sm">
                <li>
                  <Link href="/apply" className="text-ink-body no-underline hover:text-ink-display">
                    Get in touch
                  </Link>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/harryduran/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-ink-body no-underline hover:text-ink-display"
                  >
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-hairline pt-6 text-sm text-ink-muted sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 FullCast. All rights reserved.</span>
          <nav className="flex gap-4">
            <Link href="/privacy" className="text-ink-muted no-underline hover:text-ink-display">
              Privacy
            </Link>
            <Link href="/terms" className="text-ink-muted no-underline hover:text-ink-display">
              Terms
            </Link>
            <Link href="/disclosure" className="text-ink-muted no-underline hover:text-ink-display">
              Disclosure
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  )
}
